module.exports = __webpack_public_path__ + "img/brand-classic-milano.ef5e5f00.png";